export const appBaseURL = "/regali-solidali-di-natale"

export const appCdnURL = "https://regali-solidali.netlify.app"

export const appHead = {"link":[{"rel":"icon","href":"/regali-solidali-di-natale/favicon.ico","sizes":"any"}],"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"property":"og:image","content":"https://italianonprofit.it/assets/components/inp/web/uploaded/natale2023-share.png"},{"property":"og:description","content":"Ecommerce, prodotti e idee regalo per il tuo Natale: scopri i regali solidali proposti dalle organizzazioni non profit italiane"},{"property":"og:title","content":"Regali Solidali di Natale 2024: scegli fra più di 100 cause sociali"},{"property":"title","content":"Regali Solidali di Natale 2024: scegli fra più di 100 cause sociali"},{"property":"description","content":"Ecommerce, prodotti e idee regalo per il tuo Natale: scopri i regali solidali proposti dalle organizzazioni non profit italiane"},{"property":"og:type","content":"website"}],"style":[],"script":[],"noscript":[],"titleTemplate":"%s | Regali Solidali di Natale 2024","htmlAttrs":{}}

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"